import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = {
  key: 0,
  class: "text-info node_filter_results__matched_nodes_count"
}
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "text-strong" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = {
  class: "pull-right",
  style: {"margin-top":"-5px"}
}
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  id: "matchednodes",
  class: "clearfix row"
}
const _hoisted_11 = { class: "col-sm-12 container-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn = _resolveComponent("btn")!
  const _component_node_list_embed = _resolveComponent("node-list-embed")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["well well-sm matchednodes node_filter_results__matched_nodes", { 'no-margin-bottom': _ctx.noMarginBottom }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.loaded && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("count.nodes.matched", [_ctx.total, _ctx.$t("Node.count.vue", _ctx.total)])), 1))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "glyphicon glyphicon-time" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("loading.matched.nodes")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.total > _ctx.maxShown)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("count.nodes.shown", [
                _ctx.maxShown,
                _ctx.$t("Node.count.vue", _ctx.maxShown),
              ])), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.loaded && !_ctx.loading && _ctx.nodeFilter)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.viewInNodesPageUrl,
                class: "text-muted",
                style: {"margin-right":"10px"}
              }, _toDisplayString(_ctx.$t("view.in.nodes.page.prompt")), 9, _hoisted_9))
            : _createCommentVNode("", true),
          _createVNode(_component_btn, {
            type: "default btn-sm refresh_nodes",
            "data-loading-text": "${g.message(code: 'loading')}",
            disabled: _ctx.loading,
            title: _ctx.$t('click.to.refresh'),
            onClick: _ctx.update
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("refresh")) + " ", 1),
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "glyphicon glyphicon-refresh" }, null, -1))
            ]),
            _: 1
          }, 8, ["disabled", "title", "onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_node_list_embed, {
          nodes: _ctx.nodeSet.nodes,
          tagsummary: _ctx.nodeSet.tagsummary,
          "show-exclude-filter-links": true,
          onFilter: _ctx.handleFilter
        }, null, 8, ["nodes", "tagsummary", "onFilter"])
      ])
    ])
  ], 2))
}